import React, { useEffect } from "react";
import { Button, Card, PageHeader, Row } from "antd";
import { useNavigate } from "react-router-dom";
import "../styles/community.scss";

const renderCommunityContent = (navigate) => {
  return (
    <>
      <h1>Why Formi?</h1>
      <p>
        <strong>Formi</strong> is currently working on an impact and networking
        project to help aspiring entrepreneurs and freelancers to help them seek
        clarity on achieving the financial and business goals in 2022. (Age 16
        to 21)
      </p>
      <p>
        The reason for this survey is to know your current situation better and
        the roadblocks you're facing that are holding you back from achieving
        your financial goals and teenage dream of getting started with your own
        business.
      </p>
      <p>
        Based on your answers we would be able to come up with an event/online
        workshop that adds massive value and gives clarity. That would help you
        accomplish your goals in 2022.
      </p>
      <p>
        We would appreciate your honest answers in order for us to provide you
        with the best solution.
      </p>
      <p>
        PS. No! This isn't any BS promotional survey, or promo for random info
        junky online courses you see on YouTube Ads LOL.
      </p>
      <p>
        This is going to be a free event with no check-ins, opt-ins or up-sell.
      </p>
      <p>
        This impact project aims to provide younger generations of aspiring
        entrepreneurs with massive value in order to help them grow and
        simultaneously build the formi network with like minded individuals for
        mutual benefit.
      </p>
      <Row justify="center">
        <Button
          className="join-now"
          onClick={() => {
            navigate("/join-community");
          }}
        >
          Sounds interesting, I want to be a part of it
        </Button>
      </Row>
    </>
  );
};

export default function Community() {
  const navigate = useNavigate();
  useEffect(() => {
    localStorage.clear();
  }, []);
  return (
    <div className="community">
      <div className="community-header">
        <PageHeader
          className="community-header"
          onBack={() => navigate(-1)}
          title="Formi Community"
        />
      </div>
      <Row justify="center">
        <Card className="community-content">
          {renderCommunityContent(navigate)}
        </Card>
      </Row>
    </div>
  );
}
